const distributorConfig = ref(null);
let fetchPromise = null;

export const useDistributorConfig = () => distributorConfig;

export const fetchDistributorConfig = () => {
  if (!isDistributorDomain(globalThis.location?.hostname)) {
    return Promise.resolve(null);
  }
  if (distributorConfig.value) return Promise.resolve(distributorConfig.value);
  if (fetchPromise) return fetchPromise;

  fetchPromise = useApi.get('/distributor/config')
    .then((config) => {
      distributorConfig.value = config;
      fetchPromise = null;
      return config;
    })
    .catch(() => {
      fetchPromise = null;
      return null;
    });

  return fetchPromise;
};
